import { render, staticRenderFns } from "./otherItem.vue?vue&type=template&id=22c9129b&scoped=true"
import script from "./otherItem.vue?vue&type=script&lang=js"
export * from "./otherItem.vue?vue&type=script&lang=js"
import style0 from "./otherItem.vue?vue&type=style&index=0&id=22c9129b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c9129b",
  null
  
)

export default component.exports